import {
  CreateAppBackupRequest,
  SearchAppBackupsRequest,
  UpdateAppBackupRequest,
  AppBackupTrigger,
  UserCtx,
} from "@budibase/types"
import { backups, utils } from "../../../sdk"
import { events } from "@budibase/backend-core"

async function checkAppID(ctx: UserCtx, appId: string) {
  if (!(await utils.appExists(appId))) {
    ctx.throw(400, `Provided app ID: ${appId} - is invalid.`)
  }
}

export async function manualBackup(ctx: UserCtx) {
  const appId = ctx.params.appId
  await checkAppID(ctx, appId)
  const body = ctx.request.body as CreateAppBackupRequest
  const createdBy = ctx.user?._id
  const backupId = await backups.triggerAppBackup(
    appId,
    AppBackupTrigger.MANUAL,
    {
      name: body.name,
      createdBy,
    }
  )
  if (!backupId) {
    ctx.throw(500, "Unable to start backup.")
  }
  ctx.body = {
    backupId,
    message: "Backup triggered - process starting.",
  }
}

export async function importBackup(ctx: UserCtx) {
  const appId = ctx.params.appId
  await checkAppID(ctx, appId)
  const backupId = ctx.params.backupId
  const nameForBackup = ctx.request.body.name
  const response = await backups.triggerAppRestore(
    appId,
    backupId,
    nameForBackup,
    ctx.user?._id
  )
  if (!response) {
    ctx.throw(500, "Unable to start restore.")
  }
  await events.backup.appBackupRestored(response.metadata)
  ctx.body = {
    restoredId: response?.restoreId,
    message: "Restore triggered - process starting.",
  }
}

export async function deleteBackup(ctx: UserCtx) {
  const appId = ctx.params.appId
  await checkAppID(ctx, appId)
  const backupId = ctx.params.backupId
  await backups.deleteAppBackup(backupId)
  ctx.body = {
    message: "Backup deleted successfully.",
  }
}

export async function fetchBackups(ctx: UserCtx) {
  const appId = ctx.params.appId
  await checkAppID(ctx, appId)
  const body = ctx.request.body as SearchAppBackupsRequest
  if (body?.trigger) {
    body.trigger = body.trigger.toLowerCase() as AppBackupTrigger
    if (!Object.values(AppBackupTrigger).includes(body.trigger)) {
      ctx.throw(400, "Provided trigger is not a valid option.")
    }
  }
  ctx.body = await backups.fetchAppBackups(appId, {
    paginate: true,
    ...body,
  })
}

export async function updateBackup(ctx: UserCtx) {
  const appId = ctx.params.appId
  await checkAppID(ctx, appId)
  const backupId = ctx.params.backupId
  const body = ctx.request.body as UpdateAppBackupRequest
  ctx.body = await backups.updateAppBackup(backupId, body.name)
}

export async function downloadBackup(ctx: UserCtx) {
  const appId = ctx.params.appId
  await checkAppID(ctx, appId)
  const backupId = ctx.params.backupId
  const { metadata, stream } = await backups.getBackupDownloadStream(backupId)
  ctx.attachment(`backup-${metadata.timestamp}.tar.gz`)
  ctx.body = stream
}
